import {Component} from '@angular/core';
import {LoginService} from "../login/login.service";
import {UsuariosService} from "../usuarios/usuarios.service";
import {TranslateService} from '@ngx-translate/core';
import {Components} from "../shared/components/components";
import {Funcoes} from "../funcoes";
import {ActivatedRoute, Router} from "@angular/router";
import {Global} from "../global";
import {ClientesUsuariosService} from "../clientes-usuarios/clientes-usuarios.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {BasicValidators} from "../shared/basic-validators";

import { ConfiguracoesService } from "../configuracoes/configuracoes.service";

declare let swal, $:any;

@Component({
  selector: 'header-nav',
  templateUrl: 'header.component.html'
})
export class HeaderComponent extends Components{

  formTrocaSenha: FormGroup;
  userInfo: any = {};
  userTema: string = 'mirage';
  isAdm = false;
  nomeEmpresa: string = 'TopBridge';

  constructor(
    private activatedRoute: ActivatedRoute,
    protected login: LoginService,
    private usuariosService: UsuariosService,
    private clientesUsuariosService: ClientesUsuariosService,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    public global: Global,
    private formBuilder: FormBuilder,
    private configService: ConfiguracoesService
  ){
    super();
    login.getUserInfo()
      .subscribe(data => {
        this.userInfo = data;
      },
      error => {
        this.trataErro(error.json());
      });

    this.isAdm = (this.func.getTokenInfo()['adm'] == 1);

    this.carregarNomeEmpresa();

    this.formTrocaSenha = formBuilder.group({
      senha: ['', [Validators.minLength(8)]],
      senha_conf: ['', BasicValidators.igualSenha]
    });
  }

  carregarNomeEmpresa() {
    this.configService.getConfiguracoes().subscribe(
      (json: any) => {
        if (json && json.Payload && json.Payload.length > 0) {
          let item = Array.isArray(json.Payload[0]) ? json.Payload[0][0] : json.Payload[0];
          let nomeExibicao = (item && item.nome_sistema) ? item.nome_sistema : (item && item.nome_empresa ? item.nome_empresa : '');
          if (nomeExibicao) {
            this.nomeEmpresa = nomeExibicao;
            if (this.global) {
              this.global.setNomeSistema(nomeExibicao);
            }
          }
        }
      },
      error => {}
    );
  }

  setTema(tema){

    let servico;

    if(window.location.pathname.split('/')[2] == 'area-cliente'){
      this.clientesUsuariosService.atualizarTema(tema)
        .subscribe(res => {
          this.userInfo.tema = tema;
        },error => {
          this.trataErro(error.json());
        });
    }else{
      this.usuariosService.editar({"tema":tema}, this.userInfo.id_usuario)
        .subscribe(res => {
          this.userInfo.tema = tema;
        },error => {
          this.trataErro(error.json());
        });
    }

    //this.userInfo.tema = tema;
  }

  setIdioma(idioma){

    let servico;

    if(window.location.pathname.split('/')[2] == 'area-cliente'){
      servico = this.clientesUsuariosService;
    }else{
      servico = this.usuariosService;
    }

    servico.atualizarIdioma(idioma)
      .subscribe(res => {
        this.translate.use(idioma);
      },error => {
        this.trataErro(error.json());
      });
  }

  sair(){
    this.login.sair();
  }

  modalTrocaSenhaContato(){
    $('#modalAlterarSenhaContato').modal('show');
  }

  trocarSenhaContato(){
    //$('#modalAlterarSenhaContato').modal('hide');
    let form = this.formTrocaSenha.value;

    let servico;

    if(this.activatedRoute.url['value'][0].path == 'login-cliente' || this.activatedRoute.url['value'][0].path == 'nao-autorizado-cliente'){
      servico = this.clientesUsuariosService;
    }else{
      servico = this.usuariosService;
    }

    servico.salvarNovaSenha(form).subscribe((result) => {
        $('#modalTrocarSenha').modal('hide');
      },
      (erro) => servico.trataErro(erro.json()));
  }

  solicitarNovaSenha(){
    let usuariosService = this.usuariosService;

    let self = this;
    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaSolicitarNovaSenha')+self.login.getUserInfo(true).email,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true,
      },
      function(){

        usuariosService.solicitarNovaSenha(self.login.getUserInfo(true).email)
          .subscribe(res => {
              swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.emailEnviadoUsuario'), "success");
            },
            error => {
              swal(self.func.traduzir('front.erro'), self.func.traduzir('front.emailNaoEnviadoUsuario'), "error");

              self.func.showErro(error.json());
            });

      });
  }
}



// WEBPACK FOOTER //
// ./src/app/painel/header.component.ts